"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagCategory = exports.TransactionFamily = exports.InvestigationStatus = void 0;
var InvestigationStatus;
(function (InvestigationStatus) {
    InvestigationStatus["NEW"] = "NEW";
    InvestigationStatus["FALSE_POSITIVE"] = "FALSE_POSITIVE";
    InvestigationStatus["REQ_INVESTIGATION"] = "REQ_INVESTIGATION";
    InvestigationStatus["FRAUD"] = "FRAUD";
    InvestigationStatus["NOT_REQUIRED"] = "NOT_REQUIRED";
})(InvestigationStatus = exports.InvestigationStatus || (exports.InvestigationStatus = {}));
var TransactionFamily;
(function (TransactionFamily) {
    TransactionFamily["BILL"] = "BILL";
    TransactionFamily["CARD"] = "CARD";
    TransactionFamily["PERSONAL_TRANSFER"] = "PERSONAL_TRANSFER";
    TransactionFamily["EMPLOYEE_BANK_TRANSFER"] = "EMPLOYEE_BANK_TRANSFER";
    TransactionFamily["WALLET_WITHDRAWAL"] = "WALLET_WITHDRAWAL";
})(TransactionFamily = exports.TransactionFamily || (exports.TransactionFamily = {}));
var FlagCategory;
(function (FlagCategory) {
    FlagCategory["CARD_BALANCE_ALTERATION"] = "CARD_BALANCE_ALTERATION";
    FlagCategory["WALLET_BALANCE_ALTERATION"] = "WALLET_BALANCE_ALTERATION";
    FlagCategory["AML"] = "AML";
    FlagCategory["CARD_FRAUD"] = "CARD_FRAUD";
    FlagCategory["MANUAL_KEY_ENTRY"] = "MANUAL_KEY_ENTRY";
    FlagCategory["CHIP_AND_SIGNATURE"] = "CHIP_AND_SIGNATURE";
    FlagCategory["COMPLIANCE"] = "COMPLIANCE";
    FlagCategory["BILL_FRAUD"] = "BILL_FRAUD";
    FlagCategory["PERSONAL_TRANSFER_FRAUD"] = "PERSONAL_TRANSFER_FRAUD";
    FlagCategory["EMPLOYEE_BANK_TRANSFER_FRAUD"] = "EMPLOYEE_BANK_TRANSFER_FRAUD";
    FlagCategory["WALLET_WITHDRAWAL_FRAUD"] = "WALLET_WITHDRAWAL_FRAUD";
})(FlagCategory = exports.FlagCategory || (exports.FlagCategory = {}));
//# sourceMappingURL=transaction-monitoring.js.map